import { Alert, AlertProps } from 'antd';
import { FC } from 'react';

const DgAlert: FC<AlertProps> = ({ ...props }) => {
	return <Alert {...props} />;
};

export default DgAlert;
